import { smartSearchConstants } from '../constants';

export function smartSearch(
	state = {
		smartSearchText: ''
	},
	action
) {
	switch (action.type) {
		case smartSearchConstants.GET_CUSTOMERS_FILTERED_BY_NAME:
			return {
				...state,
				customersFilteredByName: action.customers
			};
		case smartSearchConstants.GET_CUSTOMERS_FILTERED_BY_USERNAME:
			return {
				...state,
				customersFilteredByUserName: action.customers
			};
		case smartSearchConstants.GET_FILTERED_CHANNELS:
			return {
				...state,
				filteredChannels: action.channels
			};
		case smartSearchConstants.GET_CUSTOMERS_FILTERED_BY_PROJECTNAME:
			return {
				...state,
				customersFilteredByProjectName: action.customers
			};
		case smartSearchConstants.GET_CUSTOMERS_FILTERED_BY_SENDER:
			return {
				...state,
				customersFilteredBySender: action.customers
			};
		case smartSearchConstants.GET_DOCS_EBID_REQUEST:
			if (action.byEBID) {
				return {
					//...state,
					search_requested: true,
					smartSearchText: action.SearchText,
					byEBID: true,
					loading_docs_ebid: true,
					docsFilteredByEBID: [],
					docsFilteredByDocNum: null,
					docsFilteredBySender: null,
					docsFilteredByReceiver: null
				};
			} else {
				return {
					//...state,
					search_requested: true,
					smartSearchText: action.SearchText,
					byEBID: false,
					loading_docs_ebid: true,
					docsFilteredByEBID: []
				};
			}

		case smartSearchConstants.GET_DOCS_EBID_SUCCESS:
			if (action.byEBID) {
				return {
					...state,
					loading_docs_ebid: false,
					byEBID: true,
					docsFilteredByEBID: action.data,
					docsFilteredByDocNum: null,
					docsFilteredBySender: null,
					docsFilteredByReceiver: null
				};
			} else {
				return {
					...state,
					loading_docs_ebid: false,
					byEBID: false,
					docsFilteredByEBID: action.data
				};
			}
		case smartSearchConstants.GET_DOCS_EBID_FAILURE:
			return {
				...state,
				loading_docs_ebid: false,
				error: action.error
			};

		case smartSearchConstants.GET_DOCS_REQUEST:
			return {
				...state,
				search_requested: true,
				byEBID: false,
				loading_docs: true,
				docsFilteredByDocNum: []
			};
		case smartSearchConstants.GET_DOCS_SUCCESS:
			return {
				...state,
				loading_docs: false,
				byEBID: false,
				docsFilteredByDocNum: action.data,
				docsShowMore: action.showMore
			};

		case smartSearchConstants.GET_DOCS_FAILURE:
			return {
				...state,
				loading_docs: false,
				error: action.error
			};
		case smartSearchConstants.GET_DOCS_SENDER_REQUEST:
			return {
				...state,
				search_requested: true,
				byEBID: false,
				loading_docs_sender: true,
				docsFilteredBySender: [],
				docsShowMoreSender: false
			};
		case smartSearchConstants.GET_DOCS_SENDER_NAME_REQUEST:
			return {
				...state,
				search_requested: true,
				byEBID: false,
				loading_docs_sender_name: true,
				docsFilteredBySenderName: [],
				docsShowMoreSenderName: false
			};
		case smartSearchConstants.GET_DOCS_SENDER_SUCCESS:
			return {
				...state,
				loading_docs_sender: false,
				byEBID: false,
				docsFilteredBySender: action.data,
				docsShowMoreSender: action.showMore
			};

		case smartSearchConstants.GET_DOCS_SENDER_NAME_SUCCESS:
			return {
				...state,
				loading_docs_sender_name: false,
				byEBID: false,
				docsFilteredBySenderName: action.data,
				docsShowMoreSenderName: action.showMore
			};

		case smartSearchConstants.GET_DOCS_SENDER_FAILURE:
			return {
				...state,
				loading_docs_sender: false,
				loading_docs_sender_name: false,
				error: action.error
			};

		case smartSearchConstants.GET_DOCS_RECEIVER_REQUEST:
			return {
				...state,
				search_requested: true,
				byEBID: false,
				loading_docs_receiver: true,
				docsFilteredByReceiver: [],
				docsShowMoreReceiver: false
			};

		case smartSearchConstants.GET_DOCS_RECEIVER_NAME_REQUEST:
			return {
				...state,
				search_requested: true,
				byEBID: false,
				loading_docs_receiver_name: true,
				docsFilteredByReceiverName: [],
				docsShowMoreReceiverName: false
			};
		case smartSearchConstants.GET_DOCS_RECEIVER_SUCCESS:
			return {
				...state,
				loading_docs_receiver: false,
				byEBID: false,
				docsFilteredByReceiver: action.data,
				docsShowMoreReceiver: action.showMore
			};

		case smartSearchConstants.GET_DOCS_RECEIVER_NAME_SUCCESS:
			return {
				...state,
				loading_docs_receiver_name: false,
				byEBID: false,
				docsFilteredByReceiverName: action.data,
				docsShowMoreReceiverName: action.showMore
			};

		case smartSearchConstants.GET_DOCS_RECEIVER_FAILURE:
			return {
				...state,
				loading_docs_receiver: false,
				loading_docs_receiver_name: false,
				error: action.error
			};

		case smartSearchConstants.GET_FILES_REQUEST:
			return {
				...state,
				search_requested: true,
				loading_files: true,
				filesFilteredByFileName: []
			};
		case smartSearchConstants.GET_FILES_SUCCESS:
			return {
				...state,
				loading_files: false,
				filesFilteredByFileName: action.data,
				filesShowMore: action.showMore
			};
		case smartSearchConstants.GET_FILES_FAILURE:
			return {
				...state,
				loading_files: false,
				error: action.error,
				filesFilteredByFileName: []
			};

		case smartSearchConstants.GET_FILES_CUSTOMER_REQUEST:
			return {
				...state,
				search_requested: true,
				loading_files_customer: true,
				filesFilteredByCustomerId: []
			};
		case smartSearchConstants.GET_FILES_CUSTOMER_SUCCESS:
			return {
				...state,
				loading_files_customer: false,
				filesFilteredByCustomerId: action.data,
				filesShowMoreByCustomerId: action.showMore
			};
		case smartSearchConstants.GET_FILES_CUSTOMER_FAILURE:
			return {
				...state,
				loading_files_customer: false,
				error: action.error,
				filesFilteredByCustomerId: []
			};
		case smartSearchConstants.GET_BATCHES_REQUEST:
			return {
				...state,
				search_requested: true,
				loading_batches: true,
				batchesFiltered: []
			};
		case smartSearchConstants.GET_BATCHES_SUCCESS:
			return {
				...state,
				loading_batches: false,
				batchesFiltered: action.data,
				batchesShowMore: action.showMore
			};
		case smartSearchConstants.GET_BATCHES_FAILURE:
			return {
				...state,
				loading_batches: false,
				error: action.error,
				batchesFiltered: []
			};
		default:
			return state;
	}
}
